export enum VehicleType {
  Land,
  Marine,
  Aerial,
}

export const vehicleTypeValues: { [id: number]: string } = {
  0: 'Terrestre',
  1: 'Marino',
  2: 'Aereo',
};

export namespace VehicleType {
  export function items() {
    return Object.keys(VehicleType)
      .filter((type) => isNaN(<any>type) && type !== 'values')
      .map((key, index) => {
        return { key: vehicleTypeValues[index], value: index };
      });
  }
}
